/**
 * Parcels Details
 */

// React
import React, { FC, useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

// Context
import AuthContext from '../../authContext';

//UI
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import theme from '../../theme';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  TextField,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiArchiveOutline,
  mdiClose,
  mdiCounter,
  mdiKeyOutline,
  mdiPackageVariantClosed,
  mdiTextBoxSearch,
} from '@mdi/js';

// Components
import ListParcelItems from './listMob';
import Pagination from '@material-ui/lab/Pagination';
import Modal from '../../components/Modal';
import { useForm } from 'react-hook-form';

// Type
import { Product, Props } from './interfaces';
import Client from 'client-sdk/src/client';
import { UpdateInventoryItemsRequestBuilder } from 'client-sdk/src/parcels/parcels';
import parcelsRepository from 'client-sdk/src/Repository/parcels-repository';
import inventoryItemsRepository from 'client-sdk/src/Repository/inventory-items-repository';
import handleError from '../../utils/handleError';
import handleNotfication from '../../utils/handleNotification';
import parcelItemsRepository from 'client-sdk/src/Repository/parcel-items-repository';

export type Input = {
  serial: string;
};

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(0),
        },
      },
    },
    paper: {
      marginTop: '16px',
      marginBottom: '16px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
    },
    allocateIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingTop: '10px',
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '.5',
        backgroundColor: '#f3ab3e',
      },
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    divider: {
      width: '98%',
      margin: '10px auto',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
    cancelTitle: {
      marginTop: '24px',
      fontSize: '12px',
      fontWeight: 500,
      textAlign: 'justify',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    collapseIcon: {
      marginTop: '-36px',
      textAlign: 'center',
      position: 'relative',
      width: '100%',
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '40px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '40px',
        borderRadius: '50%',
        backgroundColor: theme.palette.secondary.main,
        border: '5px solid white',
      },
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    showCount: {
      '& .MuiSelect-icon': {
        color: '#DFA01F',
      },
    },
    card: {
      // minWidth: '250px',
      width: '100%',
      display: 'flex',
      background: '#fff',
      padding: '8px 4px',
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    cardItem: {
      margin: '0 4px',
      flex: 1,
    },
  })
);

const Details: FC<Props> = (props: Props): React.ReactElement => {
  const history = useHistory();
  const [selected, setSelected] = React.useState<string[]>([]);
  const authContext = useContext(AuthContext);
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const [openItemsNotFound, setOpenItemsNotFound] = useState(false as boolean);
  const [openBarcode, setOpenBarcode] = useState(false as boolean);
  const [checkBarcodeDialogClosed, setCheckBarcodeDialogClosed] = useState(
    false as boolean
  );
  const [changeParcelStatusDialog, setChangeParcelStatusDialog] = useState(
    false as boolean
  );
  const [openDialogForChangeParcelStatus, setOpenDialogForChangeParcelStatus] =
    useState(false as boolean);
  const [openDialogForItemsNotUnloaded, setOpenDialogForItemsNotUnloaded] =
    useState(false as boolean);
  const [openUnloadItems, setOpenUnloadItems] = useState(false as boolean);
  const [statusChanged, setStatusChanged] = useState(false as boolean);
  const [id, setId] = useState(-1 as number);
  const [description, setDescription] = useState('');
  const [product, setProduct] = useState({} as Product);
  const { register, errors, handleSubmit, getValues, setValue, watch } =
    useForm<Input>({
      defaultValues: {
        serial: '',
      },
    });
  const [filtersValues, setFiltersValues] = useState({
    page: 0,
    size: 100,
  } as any);
  const [printModal, setPrintModal] = useState(false as boolean);
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [openHandleChangeStatus, setOpenHandleChangeStatus] =
    React.useState(false);
  const token = localStorage.getItem('token') || '';

  const [error, setError] = useState('');
  const [previewItem, setPreviewItem] = useState({} as any);
  const [inventoryItemsError, setInventoryItemsError] = useState('');
  const [inventoryItemsWithSerialError, setInventoryItemsWithSerialError] =
    useState('');
  const [inventoryItemsWithStatusError, setInventoryItemsWithStatusError] =
    useState('');
  const [loading, setLoading] = useState(false);
  const [inventoryItemsLoading, setInventoryItemsLoading] = useState(false);
  const [inventoryItemsWithSerialLoading, setInventoryItemsWithSerialLoading] =
    useState(false);
  const [inventoryItemsWithStatusLoading, setInventoryItemsWithStatusLoading] =
    useState(false);
  const [parcel, setParcel] = useState({});
  const [parcelItems, setParcelItems] = useState([]);
  const [parcelItemsStatus, setParcelItemsStatus] = useState('');
  const [inventoryItems, setInventoryItems] = useState([]);
  const [inventoryItemsWithSerial, setInventoryItemsWithSerial] = useState([]);
  const [inventoryItemsWithStatus, setInventoryItemsWithStatus] = useState([]);
  const [inventoryItemsCount, setInventoryItemsCount] = useState(0);

  const handleCollapse = () => {
    setOpen(!open);
  };

  const handleCloseSelect = () => {
    setOpenSize(false);
  };

  const handleCloseDialogForItemsNotUnloaded = () => {
    setOpenDialogForItemsNotUnloaded(false);
  };

  const handleCloseDialogForChangeParcelStatus = () => {
    setOpenDialogForChangeParcelStatus(false);
  };

  const handleSetParcelStatusFunc = (status: string) => {
    handleSetParcelStatus(status);
  };
  const updateParcelsStatus = async (action: any) => {
    const payload = { ...action };
    try {
      const callback = await parcelsRepository.updateParcelStatus({ payload });
      handleNotfication('محموله با موفقیت به روز رسانی شد', 'success');
      callback && callback();
    } catch (error) {
      handleError(error.response);
    }
  };
  const handleSetParcelStatus = (status: string) => {
    if (status === 'UNLOADED' || status === 'CONFLICTED') setDescription('');
    updateParcelsStatus({
      id: props.match.params.id,
      body: { status: status.replace(/'/g, '"'), description: description },
      pagination: {
        ...filtersValues,
      },
      callback: () => {
        setStatusChanged(!statusChanged);
        history.push('/parcels-warehouse-operator-mob');
      },
    });
    setOpenDialogForItemsNotUnloaded(false);
    setOpenDialogForChangeParcelStatus(false);
  };

  const handleOpenConfirmDisable = (item: Product, link = false) => {
    if (link) {
      if (item.status !== 'UNLOADED') {
        setStatusChanged(!statusChanged);
        handleSinglePrint(item)
          .then(_ => {
            const win = window.open(`${link}`, '_blank')!;
            win.focus();
          })
          .catch(err => {
          });
        return;
      }
      const win = window.open(`${link}`, '_blank')!;
      win.focus();
    } else {
      setId(item.id);
      setProduct(item);
    }
  };

  const getInventoryItemsWithSerial = async (action: any) => {
    const payload = { ...action };
    try {
      setInventoryItemsWithSerialLoading(true);
      const { response, callback } =
        await inventoryItemsRepository.getInventoryItemsWithSerial(
          { payload },
          payload.callback
        );
      setInventoryItemsWithSerial(response.data.content);
      if (callback) {
        callback();
      }
      if (response.data.content.length === 0)
        handleNotfication('هیچ آیتمی پیدا نشد.', 'warn');
    } catch (error) {
      setInventoryItemsWithSerialError(error.message);
      handleError(error.response);
    } finally {
      setInventoryItemsWithSerialLoading(false);
    }
  };

  // const checkSerialFunc = async () => {
  //   await getInventoryItemsWithSerial({
  //     serialNumber: {equals: serial},
  //     parcelId: {equals: props.match.params.id},
  //   });
  // };
  const checkSerial = (data: any) => {
    getInventoryItemsWithSerial({
      ...filtersValues,
      serialNumber: { equals: data.serial },
      parcelId: { equals: props.match.params.id },
      callback: () => {
        setValue('serial', '');
      },
    });
  };

  const updateInventoryItemsStatus = async (action: any) => {
    const payload = { ...action };
    try {
      const callback = await inventoryItemsRepository.updateInventoryItems({
        payload,
      });
      handleNotfication('وضعیت آیتم مورد نظر با موفقیت تغییر کرد ', 'success');
      callback && callback();
    } catch (error) {
      handleError(error.response);
    }
  };

  const handleAllocateUserFunc = () => {
    const inventoryItem = product.id ? product : inventoryItemsWithSerial[0];
    updateInventoryItemsStatus({
      id: id !== -1 ? id : inventoryItemsWithSerial[0]?.id,
      body:
        inventoryItem.status !== 'UNLOADED' ? '"UNLOADED"' : '"NOT_REGISTERED"',
      ...filtersValues,
      callback: () => {
        setStatusChanged(!statusChanged);
      },
    });
    setOpenUnloadItems(false);
  };
  const getInventoryItemWithStatus = async (action: any) => {
    const payload = { ...action };
    try {
      setInventoryItemsWithStatusLoading(true);
      const response =
        await inventoryItemsRepository.getInventoryItemsWithStatus({ payload });
      setInventoryItemsWithStatus(response.data.content);
    } catch (error) {
      setInventoryItemsWithStatusError(error.message);
      handleError(error.response);
    } finally {
      setInventoryItemsWithStatusLoading(false);
    }
  };

  const getInventoryItemsWithStatus = async () => {
    handleChangeParcelStatus();
  };

  const getNotUnloadedParcelItems = () => {
    if (parcel.items) {
      return parcel.items.filter((item: any) => item.status !== 'UNLOADED');
    }
    return [];
  };

  const handleChangeParcelStatus = () => {
    if (getNotUnloadedParcelItems().length !== 0) {
      setOpenDialogForItemsNotUnloaded(true);
    } else {
      setOpenDialogForChangeParcelStatus(true);
    }
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };
  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };

  // const handleSerial = (value: string) => {
  //   setSerial(value);
  // };

  // useEffect(() => {
  //   if (serial.length === 10) {
  //     setTimeout(() => {
  //       checkSerialFunc().then();
  //     }, 500);
  //   }
  // }, [serial]);
  const getParcelWithId = async (id: any) => {
    const payload = { id };
    try {
      setLoading(true);
      const response = await parcelsRepository.getParcelsWithId({ payload });
      setParcel(response.data);
    } catch (error) {
      setError(error.message);
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };
  const getParcelInventoryItems = async (action: any) => {
    const payload = { ...action };
    try {
      setInventoryItemsLoading(true);
      const { response, callback } =
        await inventoryItemsRepository.getParcelInventoryItems({ payload });
      setInventoryItems(response.data.content);
      setInventoryItemsCount(response.data.totalElements);
      if (callback) {
        callback();
      }
    } catch (error) {
      setInventoryItemsError(error.message);
      handleError(error.response);
    } finally {
      setInventoryItemsLoading(false);
    }
  };
  useEffect(() => {
    const { page, size } = filtersValues;
    const { id } = props.match.params;
    getParcelWithId(id);
  }, [statusChanged, filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    handleCloseBarcode(true);
  }, [inventoryItemsWithSerial]);

  /*  useEffect(() => {
    if (props.inventoryItemsWithSerial.length !== 0) {
      setSerial('');
      handleAllocateUserFunc();
    }
  }, [props.inventoryItemsWithSerial]);*/

  useEffect(() => {
    if (parcel.id) {
      getParcelInventoryItems({
        parcelId: { equals: parcel.id },
      });
      setParcelItems(parcel.items);
    }
  }, [parcel]);

  useEffect(() => {
    if (product.id) {
      handleAllocateUserFunc();
    }
  }, [product]);

  /*  useEffect(() => {
    if (props?.parcel?.status === 'UNLOADED') {
      setTimeout(() => {
        history.push('/parcels-warehouse-operator');
      }, 2000);
    }
  }, [props.parcel]);*/

  const handleClose = () => {
    setOpenUnloadItems(false);
  };

  const handleCloseItemsNotFound = () => {
    setOpenItemsNotFound(false);
  };

  const handleCloseBarcode = (setUnloaded: boolean) => {
    // setOpenBarcode(false);
    setValue('serial', '');
    if (setUnloaded && inventoryItemsWithSerial.length !== 0) {
      setId(-1);
      setProduct({} as Product);
      // setOpenUnloadItems(true);
      handleAllocateUserFunc();
    }
  };

  const handleClosePrintModal = () => {
    setPrintModal(false);
  };

  const handleOpenPrintModal = () => {
    setPrintModal(true);
  };

  const handleClick = (
    event: React.ChangeEvent<HTMLInputElement>,
    id: string
  ) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected: string[] = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleSinglePrint = async (item: Product) => {
    try {
      return await updateInventoryItemsStatus({
        id: item.id,
        body: '"UNLOADED"',
        ...filtersValues,
      });
    } catch (error) {
      throw error;
    }
  };

  const handleChangeStatus = (item: any) => {
    // setPreviewItem(item);
    // setOpenHandleChangeStatus(true);
    updateParcelItemStatus(item);
  };

  const updateParcelItemStatus = async (item: any) => {
    const { id } = props.match.params;
    const payload = {
      id: item.id,
      body:
        item.status === 'UNLOADED'
          ? 'NOT_REGISTERED'.replace(/'/g, '"')
          : 'UNLOADED'.replace(/'/g, '"'),
      callback: () => {
        getParcelWithId(id);
        setOpenHandleChangeStatus(false);
      },
    };
    try {
      setLoading(true);
      const callback = await parcelItemsRepository.updateParcelItemsStatus({
        payload,
      });
      handleNotfication(
        'تغییر وضعیت آیتم محموله با موفقیت انجام شد',
        'success'
      );
      callback && callback();
    } catch (error) {
      setError(error.message);
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };

  const closeUpdateParcelItem = () => {
    setOpenHandleChangeStatus(false);
  };

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelected = inventoryItems
        .filter((el: any) => el.status !== 'UNLOADED')
        .map((n: any) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };
  const unloadAllInventoryItems = async (ids: number[]) => {
    try {
      const request = new UpdateInventoryItemsRequestBuilder()
        .data({
          ids: ids,
        })
        .build();
      const client = new Client(token);
      await client.execute(request);
    } catch (err) {
      //err
    }
  };

  const updateMultiInventoryItemStatus = async (action: any) => {
    const payload = { ...action };
    try {
      setLoading(true);
      const response =
        await inventoryItemsRepository.updateMultiInventoryItemsStatus({
          payload,
        });
    } catch (error) {
      setError(error.message);
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };
  const handleClickPrint = () => {
    unloadAllInventoryItems(selected);
    props.history.push(
      `/print-labels/${props.match.params.id}?items=${selected.join(',')}`
    );
  };

  const handleChangePageNum = (pageNumber: number) => {
    setFiltersValues({ ...filtersValues, page: pageNumber });
  };

  const handleFilterStatus = (status: string) => {
    if (!status) {
      setParcelItems(parcel.items);
      setParcelItemsStatus(undefined);
      return;
    }
    if (parcelItemsStatus === status) {
      setParcelItemsStatus(undefined);
    } else {
      setParcelItemsStatus(status);
    }
    const newItems = parcel.items.filter((item: any) => item.status === status);
    setParcelItems(newItems);
  };

  return (
    <div className={classes.root}>
      <Grid
        style={{ marginTop: '30px', marginBottom: '20px' }}
        container
        alignItems="center"

      >
        <div className={classes.card}>
          <div className={classes.cardItem}>
            <Button
              color="secondary"
              size="medium"
              fullWidth
              variant={
                parcelItemsStatus !== 'UNLOADED' &&
                  parcelItemsStatus !== 'NOT_REGISTERED' ? 'contained' : 'outlined'
              }
              onClick={() => {
                handleFilterStatus('');
              }}
            >
              همه
            </Button>
          </div>
          <div className={classes.cardItem}>
            {filtersValues?.status}
            <Button
              fullWidth
              color="secondary"
              size="medium"
              variant={
                parcelItemsStatus === 'UNLOADED' ? 'contained' : 'outlined'
              }
              onClick={() => {
                handleFilterStatus('UNLOADED');
              }}
            >
              تخلیه شده
            </Button>
          </div>
          <div className={classes.cardItem}>
            <Button
              fullWidth
              color="secondary"
              size="medium"
              variant={
                parcelItemsStatus === 'NOT_REGISTERED' ? 'contained' : 'outlined'
              }
              onClick={() => {
                handleFilterStatus('NOT_REGISTERED');
              }}
            >
              تخلیه نشده
            </Button>
          </div>
        </div>

      </Grid>
      <Grid xs={12} container item>
        <Grid item xs={12}>
          {!parcel ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            parcelItems && (
              <ListParcelItems
                changeStatus={(item: any) => handleChangeStatus(item)}
                data={parcelItems}
              />
            )
          )}
        </Grid>
        <Grid xs={12} sm={12} container item direction="row-reverse" style={{ marginTop: '12px' }} >
          {inventoryItems && (
            <>
              <Pagination
                count={Math.ceil(parcel.boxCount / filtersValues.size)}
                color="secondary"
                page={filtersValues.page + 1}
                onChange={handleChangePage}
              />
            </>
          )}
        </Grid>
        <Grid sm={12} container item style={{ position: 'fixed', bottom: '5px', paddingLeft: '40px' }} >
          <Divider style={{ width: '100%', marginBottom: '8px' }} />
          <Button
            aria-label="unload-parcel"
            onClick={getInventoryItemsWithStatus}
            variant="contained"
            color="primary"
            fullWidth
          >
            {'تایید تخلیه محموله'}

          </Button>
        </Grid>
      </Grid>
      <Dialog
        fullWidth
        open={openUnloadItems}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              top: '5px',
              left: '5px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton aria-label="close" onClick={handleClose}>
                <Icon path={mdiClose} size={.8} />
              </IconButton>
            ) : null}
          </div>

          <div>
            {id !== -1 || inventoryItemsWithSerial.length === 0 ? (
              <div>
                {` از
            تغییر وضعیت کالا با شناسه
            "${id}"
            به
            "${product.status === 'UNLOADED' ? 'تخلیه نشده' : 'تخلیه شده'}"
          مطمئن هستید؟`}
              </div>
            ) : (
              <div>
                <Grid
                  style={{ marginBottom: '15px' }}
                  container
                  alignItems="center"
                >
                  <Grid item xs={12} sm={4}>
                    <div className={classes.item}>
                      <span className={classes.label}>
                        <Icon
                          path={mdiArchiveOutline}
                          size={1}
                          className={classes.icon}
                        />
                        {'نام کالا :  '}
                      </span>
                      <span>{inventoryItemsWithSerial[0]?.productName}</span>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <div className={classes.item}>
                      <span className={classes.label}>
                        <Icon
                          path={mdiKeyOutline}
                          size={1}
                          className={classes.icon}
                        />
                        {'شناسه کالا :  '}
                      </span>
                      <span>{inventoryItemsWithSerial[0]?.productId}</span>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <div className={classes.item}>
                      <span className={classes.label}>
                        <Icon
                          path={mdiCounter}
                          size={1}
                          className={classes.icon}
                        />
                        {'تعداد :  '}
                      </span>
                      <span>{inventoryItemsWithSerial[0]?.amount}</span>
                    </div>
                  </Grid>
                </Grid>
                <div className={classes.cancelTitle}>
                  {` از
            تغییر وضعیت کالا با مشخصات بالا
            به تخلیه شده
          مطمئن هستید؟`}
                </div>
              </div>
            )}
          </div>
        </DialogTitle>
        <Divider />
        <DialogActions style={{ padding: '8px 16px' }}>
          <Grid container spacing={1}>
            <Grid item xs={6}>

              <Button
                onClick={handleAllocateUserFunc}
                fullWidth
                variant="contained"
                size="medium"
              >
                {'بله'}
              </Button>
            </Grid>

            <Grid item xs={6}>
              <Button
                fullWidth
                autoFocus
                onClick={handleClose}
                variant="outlined"
                color="primary"
                size="medium"
              >
                {'خیر'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openDialogForChangeParcelStatus}
        onClose={handleCloseDialogForChangeParcelStatus}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              top: '5px',
              left: '5px',
              zIndex: 10,
            }}
          >
            {handleCloseDialogForChangeParcelStatus ? (
              <IconButton
                aria-label="close"
                onClick={handleCloseDialogForChangeParcelStatus}
              >
                <Icon path={mdiClose} size={.8} />
              </IconButton>
            ) : null}
          </div>

          <div className={classes.cancelTitle}>
            {` از 
            تغییر وضعیت محموله به تخلیه شده
          مطمئن هستید؟`}
          </div>
        </DialogTitle>
        <Divider />
        <DialogActions style={{ padding: '8px 16px' }}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Button
                onClick={e => handleSetParcelStatusFunc('UNLOADED')}
                fullWidth
                variant="contained"
                size="medium"
                color='primary'
              >
                {'تخلیه'}
              </Button>
            </Grid>

            <Grid item xs={6}>
              <Button
                fullWidth
                autoFocus
                onClick={handleCloseDialogForChangeParcelStatus}
                variant="outlined"
                color="primary"
                size="medium"
              >
                {'انصراف'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openHandleChangeStatus}
        onClose={closeUpdateParcelItem}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              top: '5px',
              left: '5px',
              zIndex: 10,
            }}
          >
            {closeUpdateParcelItem ? (
              <IconButton aria-label="close" onClick={closeUpdateParcelItem}>
                <Icon path={mdiClose} size={.8} />
              </IconButton>
            ) : null}
          </div>

          <div className={classes.cancelTitle}>
            {` از 
            تغییر وضعیت آیتم محموله با شناسه
             "${previewItem.id}"
             به 
             "${previewItem.status === 'UNLOADED' ? 'تخلیه نشده' : 'تخلیه شده'}"
          مطمئن هستید؟`}
          </div>
        </DialogTitle>
        <Divider />
        <DialogActions style={{ padding: '8px 16px' }}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Button
                onClick={e => updateParcelItemStatus()}
                fullWidth
                variant="contained"
                size="medium"
                color='primary'
              >
                {'بله'}
              </Button>
            </Grid>

            <Grid item xs={6}>
              <Button
                fullWidth
                autoFocus
                onClick={closeUpdateParcelItem}
                variant="outlined"
                color="primary"
                size="medium"
              >
                {'خیر'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openDialogForItemsNotUnloaded}
        onClose={handleCloseDialogForItemsNotUnloaded}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              top: '5px',
              left: '5px',
              zIndex: 10,
            }}
          >
            {handleCloseDialogForItemsNotUnloaded ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleCloseDialogForItemsNotUnloaded}
              >
                <Icon path={mdiClose} size={.8} />
              </IconButton>
            ) : null}
          </div>

          <div className={classes.cancelTitle}>
            {getNotUnloadedParcelItems().length > 1 ? (
              <div>
                {`تعداد 
                "${getNotUnloadedParcelItems().length}"
                آیتم از کالاها
                مانند آیتم با مشخصات 
              "${'نام کالا'} : ${getNotUnloadedParcelItems()[0]?.productName
                  }  - ${'شناسه تنوع کالا'} : ${getNotUnloadedParcelItems()[0]?.skuId
                  }"
              هنوز تخلیه نشده است و یا مغایرت دارد.`}
              </div>
            ) : (
              <div>
                {`آیتم با شناسه 
                "${getNotUnloadedParcelItems()[0]?.id}"
                هنوز تخلیه نشده است و یا مغایرت دارد.
                `}
              </div>
            )}
          </div>
        </DialogTitle>
        <Divider />
        <DialogActions style={{ padding: '8px 16px' }}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Button
                fullWidth
                autoFocus
                onClick={handleCloseDialogForItemsNotUnloaded}
                variant="contained"
                color="secondary"
                size="medium"
              >
                {'بررسی مجدد'}
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                onClick={e => handleSetParcelStatusFunc('CONFLICTED')}
                fullWidth
                variant="contained"
                size="medium"
              >
                {'ایجاد مغایرت'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openItemsNotFound}
        onClose={handleCloseItemsNotFound}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              top: '5px',
              left: '5px',
              zIndex: 10,
            }}
          >
            {handleCloseItemsNotFound ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleCloseItemsNotFound}
              >
                <Icon path={mdiClose} size={.8} />
              </IconButton>
            ) : null}
          </div>

          <div className={classes.cancelTitle}>
            {`آیتم مورد نظر با سریال 
            " ${getValues().serial} "
            یافت نشد.`}
          </div>
        </DialogTitle>
        <Divider />
        <DialogActions style={{ padding: '8px 16px' }}>
          <Grid container justify="flex-end">
            <Button
              autoFocus
              onClick={handleCloseItemsNotFound}
              variant="contained"
              color="secondary"
              size="medium"
            >
              {'باشه'}
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
      <Modal
        maxWidth="lg"
        onClose={() => setOpenBarcode(false)}
        open={openBarcode}
        title={
          <div>
            <Icon
              path={mdiPackageVariantClosed}
              size={4}
              color={theme.palette.green.main}
            />
          </div>
        }
        content={
          <form onSubmit={handleSubmit(checkSerial)}>
            <Grid container>
              <Grid xs={12}>
                <div
                  style={{
                    width: '100%',
                    marginBottom: '30px',
                  }}
                >
                  <TextField
                    fullWidth
                    autoFocus
                    id="serial"
                    name="serial"
                    label="سریال"
                    inputRef={register({ required: true })}
                    error={errors.serial && true}
                  />
                </div>
              </Grid>
              <Grid xs={12} container justify="flex-end">
                <Button
                  variant="contained"
                  color="secondary"
                  type="submit"
                  size="medium"
                  startIcon={<Icon path={mdiTextBoxSearch} size={1} />}
                  disabled={watch('serial')?.length === 0}
                >
                  {'یافتن کالا'}
                </Button>
              </Grid>
            </Grid>
          </form>
        }
      />
    </div>
  );
};

export default Details;
